/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const jiraFieldValueSchema = z.object({
  id: z.string(),
  isMapped: z.boolean(),
  name: z.string(),
});
